import React from "react";
import ContainerWrapper from "./ContainerWrapper";
import ActivityLogMain from "Components/ActivityLog/ActivityLogMain";
// const ActivityLogMain = React.lazy(() =>
//   import("Components/ActivityLog/ActivityLogMain")
// );

const ActivityLog = () => {
  return (
    // <ContainerWrapper>
    <ActivityLogMain />
    // </ContainerWrapper>
  );
};

export default ActivityLog;
